import { summary, stats } from "../../data/resume";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-paper"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left: heading */}
          <div className="lg:col-span-5 reveal">
            <p className="text-sm uppercase tracking-[0.2em] font-semibold text-slate-500 mb-4">
              About
            </p>
            <h2 className="font-serif font-semibold text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
              A finance partner to executive leadership.
            </h2>
            <div className="mt-8 h-px w-24 bg-brass" />
            <p className="mt-8 text-base text-slatey leading-relaxed">
              {profileBio}
            </p>
          </div>

          {/* Right: summary + stats */}
          <div className="lg:col-span-7 reveal" style={{ transitionDelay: "0.1s" }}>
            <p className="text-lg sm:text-xl text-slatey leading-relaxed font-light">
              {summary}
            </p>

            <div className="mt-12 grid grid-cols-2 gap-px bg-border border border-border">
              {stats.map((s) => (
                <div
                  key={s.label}
                  data-testid={`about-stat-${s.value}`}
                  className="bg-white p-7 md:p-8"
                >
                  <div className="font-serif font-bold text-ink text-3xl md:text-4xl tracking-tight">
                    {s.value}
                  </div>
                  <div className="mt-2 text-sm text-slate-500 leading-snug">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const profileBio =
  "Dr. David Homer is a strategic finance leader with deep expertise across financial planning & analysis, budgeting, and data analytics. Over nearly a decade overseeing public-sector budgets, he has built a reputation for turning complex financial data into clear, actionable insight — strengthening controls, improving forecasting accuracy, and helping leadership make confident, fiscally responsible decisions.";
